import React from "react"
import { Box, IconButton } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import ReportFormHeaderTitle from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Header/Title"
import ReportFormHeaderNumSearches from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Header/NumSearches"
import { closeDrawer } from "Pages/ReportsAlerts/Reports/@signals"
import { dsColorNew } from "@palette"


export default function ReportFormHeader() {

	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.75, px: 3, py: 1.5 }}>
		{/* the same as Cancel */}
		<IconButton aria-label="Back to the list" onClick={closeDrawer} sx={{ width: 34, height: 34, borderRadius: '8px', border: `1px solid ${dsColorNew.grayBorder}`, color: dsColorNew.textMuted }}>
			<IconSeeker icon="arrow-left" sx={{ fontSize: 14 }}/>
		</IconButton>
		<ReportFormHeaderTitle/>
		<Box sx={{ ml: 'auto' }}>
			<ReportFormHeaderNumSearches/>
		</Box>
	</Box>
}
